import { breakpoints } from '@bnnvara/breakpoints';
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import * as S from '../components/common/styled';
import { AUDIO_TYPE } from './types';

export const NPOLink = styled.p`
  font-size: 16px;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoints.md} {
    font-size: 18px;
  }

  ${breakpoints.lg} {
    font-size: 20px;
  }

  a {
    color: red;
  }
`;

export const CantBeFoundAudio = styled.div`
  text-align: center;
`;

export const TopIcons = styled.div`
  position: absolute;
  z-index: 99;
  right: 20px;
  top: 20px;
  display: flex;
  align-items: center;
  opacity: 0;
  visiblity: hidden;

  ${({ status }) =>
    status === 'active' &&
    `
    opacity: 1;
    visibiliy: visible;
  `};

  ${({ status }) =>
    status === 'inactive' &&
    `
    opacity: 0;
    visibiliy: hidden;
    transition: visibility 1s, opacity 1s;
  `};

  > a,
  > button {
    margin-left: 12px;
    padding: 1px 6px;

    ${breakpoints.md} {
      margin-left: 28px;
    }
  }
`;

export const Iframe = styled.iframe`
  height: ${(props) => (props.type === AUDIO_TYPE ? '50px' : '100%')};
`;

export const ShareToggleButton = styled.button`
  ${S.baseButton}
`;
